import { useQuery } from '@tanstack/react-query'
import { measurementService } from '@/services/measurement.service'
import type { MeasurementFilters } from '@/types/measurement.types'

export const useMeasurements = (deviceId: string, filters?: MeasurementFilters) => {
  return useQuery({
    queryKey: ['measurements', deviceId, filters?.startDate, filters?.endDate, filters?.limit],
    queryFn: () => measurementService.getMeasurements(deviceId, filters),
    enabled: !!deviceId,
    staleTime: 0 // Always refetch when query key changes
  })
}

export const useLatestMeasurement = (deviceId: string) => {
  return useQuery({
    queryKey: ['measurement', 'latest', deviceId],
    queryFn: () => measurementService.getLatestMeasurement(deviceId),
    enabled: !!deviceId,
    refetchInterval: 30000
  })
}

export const useChartData = (deviceId: string, parameter: string, filters?: MeasurementFilters) => {
  return useQuery({
    queryKey: ['chart-data', deviceId, parameter, filters],
    queryFn: () => measurementService.getChartData(deviceId, parameter, filters),
    enabled: !!deviceId && !!parameter,
    staleTime: 60000
  })
}
